export default __webpack_public_path__ + "static/media/admins.a6243eba.svg";